import { Component, Input } from '@angular/core';

@Component({
  selector: 'copyright-footer',
  template: require('./copyright-footer.component.html'),
  styles: [require('./copyright-footer.component.less')],
  preserveWhitespaces: true
})

export class CopyrightFooterComponent {

  termsOfUseUrl: string = 'https://practicecatapult.com/termsofuse/';
  privacypolicyUrl: string = 'https://practicecatapult.com/privacy-policy/';
  webSiteUrl: string = 'https://orthocatapult.com/';

  @Input() isLogin: any;
  @Input() sideBarOpened: any;

  openNewTab(option: any) {
    if (option === 'privacy') {
      window.open(this.privacypolicyUrl, '_blank', '');
    } else if (option === 'terms') {
      window.open(this.termsOfUseUrl, '_blank', '');
    } else if (option === 'website') {
      window.open(this.webSiteUrl, '_blank', '');
    }
  }
}